import AdminModal from './AdminModal';
export default AdminModal;